import { IconName } from './Icon';
import { iconNameMap } from './util';

export const ICON_NAMES: IconName[] = Object.keys(iconNameMap).sort((a, b) => a.localeCompare(b)) as IconName[];
